// A failed dynamic import (a route chunk that 404s, or — as seen in production —
// is served as the SPA index.html with a `text/html` MIME type from a poisoned
// CDN cache) surfaces as one of these messages. These are recoverable by
// loading a fresh page.
const CHUNK_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'failed to load module script',
];

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error) {
    return false;
  }

  if (error instanceof Error && error.name === 'ChunkLoadError') {
    return true;
  }

  const message = (
    error instanceof Error ? error.message : String(error)
  ).toLowerCase();

  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
};
